import PermissionService from '@Services/PermissionService';
import React, { lazy } from 'react';
const TransactionCurrencyList = lazy(() => import('./components/TransactionCurrencyList/TransactionCurrencyList'));

export const transactionCurrencyConfig = [
	{
		auth: true,
		component: <TransactionCurrencyList />,
		name: 'transaction_currency',
		path: '/transaction-currency',
		pm: (pm) => PermissionService(pm).getOrder(),
	},
]